import React from 'react'
import { Typography, useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { CalendarIcon } from 'redesign/components/atoms/Icon'
import TimelineIconText from 'redesign/components/molecules/timeline-icon-text'
import { DATE_FORMAT_VARIANTS } from 'redesign/shared/date/constants'
import { formatDateRange } from 'redesign/shared/date/utils'
import type { TimelineDateProps } from './types'

const TimelineDate: React.FC<TimelineDateProps> = ({ startDate, endDate }) => {
  const { palette } = useTheme()
  const { t, locale } = useFavurTranslation()

  return (
    <TimelineIconText icon={CalendarIcon} color={palette.text.secondary}>
      <Typography color={palette.text.primary} variant="subtitle2">
        {formatDateRange({
          dates: { startDate, endDate },
          dateFormat: DATE_FORMAT_VARIANTS.shortWithWeekday,
          locale,
          t,
        })}
      </Typography>
    </TimelineIconText>
  )
}

export default TimelineDate
